import { Model } from '@vuex-orm/core';
import Zaui from '@/include/api';

import Activity from '@/models/Activity';
import Product from '@/models/Product';
import Package from '@/models/Package';

export default class CartItem extends Model {
  static entity = 'cartitems';

  get detailsModel() {
    let models = {product: Product, activity: Activity, package: Package};
    return models[this.type];
  }

  get imageUrl() {
    return (this.details && this.details.image) ? this.details.image : require('@/assets/images/abstract.png');
  }

  get details() {
    let details = null;
    let model = this.detailsModel;
    if (model) {
      details = model.find(this.itemId);

      if (!details) {
        if(model) {
            if (this.type === 'product') {
              model.fetch(this.itemId, {packageId: this.packageId, linkedToTourId: this.linkedToTourId, linkedToPackageId: this.linkedToPackageId });
            } else if (this.type === 'activity') {
              model.fetch(this.itemId, null, {packageId: this.packageId});
            } else {
              model.fetch(this.itemId);
            }
        }
      }
    }
    return details;
  }

  get activityPriceBreakdown() {
    if (!this.details || !this.details.price) {
      return [];
    }

    let prices = [];
    let optionPrices = [];

    if (this.details) {
      // First create the pax breakdown
      let type = 'pax';

      // add the options breakdown
      if (this.options) {
        type = 'option';
        this.options.forEach(cartOption => {
          let qty = cartOption.value;
          if (qty) {
            let filtered = this.details.options.filter(item => item.categoryId === cartOption.id);
            let activityOption = filtered && filtered.length ? filtered[0] : null;
            if (activityOption) {
              let unitPrice = activityOption.price;
              let subTotal = qty * unitPrice;
              let label = activityOption.name;

              optionPrices.push({ type, label, qty, unitPrice, subTotal,
                                  addToInventory: activityOption.addToInventory,
                                  mapToSeniors: activityOption.mapToSeniors,
                                  mapToAdults: activityOption.mapToAdults,
                                  mapToStudents: activityOption.mapToStudents,
                                  mapToChildren: activityOption.mapToChildren,
                                  mapToInfants: activityOption.mapToInfants
               });
            }
          }
        });
      }

      if (this.pax) {
        type = 'pax';

        ['seniors', 'adults', 'students', 'children', 'infants'].forEach(p => {
          let qty = this.pax[p];

          if (qty) {
            let label = p;
            let unitPrice = this.details.price[p];
            if(this.details.activityType == 'rental' && (this.rentalStartTime || this.startTime) && this.rentalEndDate && (this.rentalEndTime || this.endTime)){
              let dateTime1 = new Date(this.date+ ' ' + (this.rentalStartTime ? this.rentalStartTime : this.startTime));
              let dateTime2 = new Date(this.rentalEndDate.includes(':') ? this.rentalEndDate : this.rentalEndDate + ' ' + (this.rentalEndTime ? this.rentalEndTime : this.endTime));
              let rentalHours = (dateTime2.getTime() - dateTime1.getTime()) /3600000;
              let rentalPrice = this.details.rentalPrice.find(e => { return e['startRange'] <= rentalHours && e['endRange'] >= rentalHours});
              unitPrice = rentalPrice ? rentalPrice[p+'FlatRate'] : unitPrice;
            }
            let subTotal = qty * unitPrice;
            prices.push({ type, label, qty, unitPrice, subTotal });
          }
        });
      }
    }
    return prices.concat(optionPrices);
  }

  get subTotal() {
    let subTotal = 0;

    if (this.details) {
      if (this.type === 'product') {
        subTotal = this.details.price * this.quantity;
      } else if (this.type === 'activity' || this.type === 'package') {
        subTotal = this.activityPriceBreakdown.reduce((cur, item) => {
          return cur + item.subTotal;
        }, 0);
      }
    } else if (this.type === 'giftcert') {
      subTotal = this.giftAmount;
    }

    return subTotal;
  }

  static fields() {
    return {
      id: this.number(),
      itemId: this.number(),
      type: this.string(),      // activity | product | package | p2p | giftcert
      name: this.string(),
      image: this.string(),
      total: this.number(),

      cartId: this.attr(),  // use in frontend only - manually set

      /* activity / p2p */
      pax: this.attr(),

      /* activity */
      date: this.attr(),
      tempMonth: this.attr(),
      startTime: this.attr(),
      pickupLocation: this.attr(),
      pickupAddress: this.attr(),
      dropoffLocation: this.attr(),
      dropoffAddress: this.attr(),

      pickupStartTime: this.attr(),
      pickupEndTime: this.attr(),
      dropoffStartTime: this.attr(),
      dropoffEndTime: this.attr(),

      options: this.attr([]),
      meals: this.attr([]),
      tickets: this.attr([]),

      /* activity - rentals */
      endTime: this.attr(),
      customRentalTime: this.attr(),
      rentalStartTime: this.attr(),
      rentalEndTime: this.attr(),
      rentalEndDate: this.attr(),
      rawRentalEndDate: this.attr(),

      /* package */
      packageId: this.number(),
      packageActivities: this.attr(), // CartItem<activity>[]
      packageProducts: this.attr(),   // CartItem<product>[]
      dateChanging: this.boolean(), // belongs to activity but package related, indicates a date is currently changing

      /* p2p */
      fromCityId: this.number(),
      toCityId: this.number(),

      /* product */
      quantity: this.number(0),

      /* linked product */
      linkedToTourId: this.number(),
      linkedToPackageId: this.number(),

      /* giftcert */
      giftAmount: this.number(),
      giftDate: this.attr(),  // ? not used?
      giftFirstName: this.string(),
      giftLastName: this.string(),
      giftEmail: this.string(),
      giftMessage: this.string(),
    };
  }
}